/*
|--------------------------------------------------------------------------
| Helpers / Utilities
|--------------------------------------------------------------------------
|
| This file contains:
| - jQuery extensions (e.g. $.fn.* helpers)
| - Global utility functions
| - Cross-cutting infrastructure helpers
| - Small reusable, framework-level helpers
|
| This file should NOT contain:
| - UI component initialization
| - Page-specific behavior
| - Grid-specific logic
| - DOM-ready bootstrap logic
|
| Think: foundational tools used by other JS modules.
|
*/

//#region JQuery Extensions
$.fn.findExclude = function (selector: string, mask: string, result?: JQuery) {
    var res = result || $();

    this.children().each(function () {
        var $this = $(this);

        // If element matches the selector, add it
        if ($this.is(selector)) {
            res = res.add(this);
        }

        // Only recurse if this element does NOT match the mask
        if (!$this.is(mask)) {
            res = $this.findExclude(selector, mask, res);
        }
    });

    return res;
}

$.fn.findInGrid = function (selector: string): JQuery {
    return this.findExclude(selector, '.gridBinder');
}

$.fn.visible = function (isVisible: boolean): JQuery {
    return this.each(function () {
        if (isVisible) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
};
//#endregion JQuery Extensions

//#region Bootstrap Helpers
function getModal($el: JQuery<any>) {
    return bootstrap.Modal.getInstance($el[0]) || new bootstrap.Modal($el[0]);
}
//#endregion Bootstrap Helpers

function getQueryStringParameter(name: string): string | null {
    // Get the URL query string
    var queryString = window.location.search.substring(1);

    // Split the query string into key-value pairs
    var queryParams = queryString.split("&");

    // Iterate through the key-value pairs to find the parameter with the given name
    for (var i = 0; i < queryParams.length; i++) {
        var pair = queryParams[i].split("=");
        if (pair[0] === name) {
            // Decode and return the parameter value
            return decodeURIComponent(pair[1]);
        }
    }

    // Return null if the parameter is not found
    return null;
}

function generateGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function showDeleteConfirmModal(message: string, dataHtml: string, callback: () => void): void {
    // Set the confirmation message
    $('#deleteConfirmMessage').html(message);

    $('#deleteConfirmData').html(dataHtml);

    var $modal = $('#deleteConfirmModal');

    //Clear Out Any Error Messages Left Over
    clearMessageErrors($modal);

    // Show the modal
    getModal($modal).show();

    // Bind the click event for the confirmation button
    $('#btnConfirmDelete').off('click').on('click', function () {
        callback();
    });
}

function getHiddenElementOuterWidth($el: JQuery): number {
    if ($el.is(':visible')) {
        return $el.outerWidth() ?? 0; // If already visible, return the width
    }

    // Clone the element
    var $clone = $el.clone().css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block'
    }).appendTo('body'); // Append it to the body to measure

    var width = $clone.outerWidth() ?? 0; // Get the width

    $clone.remove(); // Clean up

    return width;
}

//#region _SaveMessage Helpers
function getMessagePlaceHolder($context: JQuery<HTMLElement>): JQuery<HTMLElement> {
    const $el = $context.findInGrid('div[name="messagePlaceHolder"]').first();

    if (!$el.length) {
        console.warn('MessagePlaceholder not found in context:', $context);
    }

    return $el;
}

function appendMessagePartial($context: JQuery<HTMLElement>, html?: string): void {
    if (!html || html.trim() === '') {
        return;
    }

    const $placeholder = getMessagePlaceHolder($context);

    if (!$placeholder.length) {
        return;
    }

    const $newContent = $(html);

    // If the returned HTML already contains a messagePlaceHolder, replace entire element
    const $newPlaceholder = $newContent.filter('[name="messagePlaceHolder"]');

    if ($newPlaceholder.length) {
        $placeholder.replaceWith($newPlaceholder);
    } else {
        // fallback if partial does NOT include wrapper
        $placeholder.empty().append($newContent);
    }
}

function setMessageError($context: JQuery<HTMLElement>, message: string): void {
    getMessagePlaceHolder($context).html(`<div class="text-danger">${message}</div>`);
}

function clearMessageErrors($context: JQuery<HTMLElement>): void {
    getMessagePlaceHolder($context).html(``);
}
//#endregion _SaveMessage Helpers

function getDownloadedFileNameFromDisposition(contentDisposition: string | null, fallback: string): string {
    if (!contentDisposition) {
        return fallback;
    }

    // Try RFC 5987 format first (filename*=)
    const utf8Match = contentDisposition.match(/filename\*\=UTF-8''([^;]+)/i);
    if (utf8Match && utf8Match[1]) {
        return decodeURIComponent(utf8Match[1]);
    }

    // Fallback to basic filename=
    const fileNameMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    if (fileNameMatch && fileNameMatch[1]) {
        return fileNameMatch[1];
    }

    return fallback;
}

//#region Global AJAX loading spinner
(function () {
    let ajaxPending = false;
    const delayMillis = 250;

    $(document)
        .ajaxStart(function () {
            ajaxPending = true;

            setTimeout(function () {
                if (ajaxPending) {
                    $('#loading-panel').show();
                }
            }, delayMillis);
        })
        .ajaxStop(function () {
            ajaxPending = false;
            $('#loading-panel').hide();
        });
})();
//#endregion Global AJAX loading spinner